import React from "react";
import { connect } from "react-redux";
// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FormControl, FormLabel, Select, Alert, AlertTitle } from "@mui/material";
import { Close, Map } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import JamezzTable from "../../../components/JamezzTable/JamezzTable";
import tafelStyle from "../../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import * as actions from "../../../store/actions";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { convertArrayToSelectOptions } from "../../../templateHelpers";

//###
import axios from "axios";
import DialogContent from "@mui/material/DialogContent";
import CustomInput from "../../../components/CustomInput/CustomInput";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import SaveButton from "../../../components/CustomInput/SaveButton";
import { toast } from "react-toastify";
//###

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class PostcodesModal extends React.Component {
  state = {
    mode: 1,
    addToWhiteList: false,
    addToBlackList: false,
    removeFromList: false,
    postcode_intake: "",
    minBasketPrice_intake: 0.0,
  };

  jamezzTable = React.createRef();

  /* gridText vars */
  gridTextWhiteListed = getTranslation("postcode_blacklists.gridText.whitelisted", "OK TO DELIVER");
  gridTextBlackListed = getTranslation("postcode_blacklists.gridText.blacklisted", "BLACKLISTED");

  handlePostcodeIntakeChange = (event) => {
    this.setState({ postcode_intake: event.target.value });
  };
  handleMinBasketPriceIntakeChange = (event) => {
    this.setState({ minBasketPrice_intake: event.target.value });
  };

  sent = (type) => {
    switch (type) {
      case "addPostcodeToWhitelist":
        this.setState({ addToWhiteList: true });
        break;
      case "addPostcodeToBlacklist":
        this.setState({ addToBlackList: true });
        break;
      case "removePostcodeFromList":
        this.setState({ removeFromList: true });
        break;
    }

    let data = {
      postcode_intake: this.state.postcode_intake,
      minBasketPrice_intake: this.state.minBasketPrice_intake,
      type: type,
    };

    axios
      .post("/core/postcode_blacklists/" + this.props.vestiging_id + "/addPostcodesNL", data)
      .then((response) => {
        switch (type) {
          case "addPostcodeToWhitelist":
            this.setState({ addToWhiteList: false });
            break;
          case "addPostcodeToBlacklist":
            this.setState({ addToBlackList: false });
            break;
          case "removePostcodeFromList":
            this.setState({ removeFromList: false });
            break;
        }

        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.jamezzTable.current?.refreshData();
        } else {
          this.setState({
            addToWhiteList: false,
            addToBlackList: false,
            removeFromList: false,
          });
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
  };

  disableSent = () => {
    return this.state.postcode_intake === "";
  };

  customRender_white = (tableField) => {
    if (tableField !== undefined) {
      if (tableField == 1) {
        return "<span>" + this.gridTextWhiteListed + "</span>";
      } else {
        return (
          "<span style='background-color:red;color:white'><strong>&nbsp" +
          this.gridTextBlackListed +
          "&nbsp</strong></span>"
        );
      }
    } else {
      return "undefined(?)";
    }
  };

  customRender_id = (tableField) => {
    if (tableField !== undefined) {
      return "<span></span>"; //hide for user
    } else {
      return "undefined(?)";
    }
  };

  render() {
    const { classes } = this.props;

    const showActiveFilter = [
      {
        value: "ALL",
        label: getTranslation("postcode_blacklists.filters.setview.filterOffWhite", "Show all postcodes"),
      },
      {
        value: "0",
        label: getTranslation("postcode_blacklists.filters.setview.blacklisted", "Show blacklisted postcodes"),
      },
      {
        value: "1",
        label: getTranslation("postcode_blacklists.filters.setview.whitelisted", "Show whitelisted postcodes"),
      },
    ];
    const showActiveOptions = convertArrayToSelectOptions(showActiveFilter, classes);

    return (
      <div>
        <Dialog
          TransitionComponent={Transition}
          aria-describedby={"notice-modal-slide-description"}
          aria-labelledby={"notice-modal-slide-title"}
          fullWidth
          keepMounted
          maxWidth={"lg"}
          onClose={this.props.toggle}
          open={this.props.open}
        >
          <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
            <GridContainer>
              <GridItem sm={11} xs={12} />

              <GridItem sm={1} xs={12}>
                <Button
                  aria-label={"Close"}
                  className={classes.modalCloseButton}
                  color={"transparent"}
                  justIcon
                  key={"close"}
                  onClick={this.props.toggle}
                >
                  <Close className={classes.modalClose} />
                </Button>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12}>
                <Alert severity={"info"} style={{ marginBottom: "15px" }}>
                  <AlertTitle>Info</AlertTitle>
                  <TranslationWrapper
                    tDefault={"Please be aware that the minimum order value only works when order limits are enabled."}
                    tKey={"vestigingen.modal.postcodes.info"}
                  />
                </Alert>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper
                    tDefault={"Postcode(s)"}
                    tKey={"vestigingen" + "." + "modal.testmail.form.postcodes"}
                  />
                </FormLabel>
              </GridItem>

              <GridItem sm={6} xs={12}>
                <CustomInput
                  formControlProps={{
                    fullWidth: true,
                  }}
                  id={"postcode_intake_id"}
                  inputProps={{
                    type: "text",
                    name: "postcode_intake_name",
                    onChange: this.handlePostcodeIntakeChange,
                  }}
                />
              </GridItem>
              <GridItem sm={2} xs={12}>
                <CustomInput
                  formControlProps={{
                    fullWidth: true,
                  }}
                  id={"minBasketPrice_intake_id"}
                  inputProps={{
                    type: "text",
                    name: "minBasketPrice_intake_name",
                    placeholder: getTranslation("postcode_blacklists.table.minBasketPrice", "Minimum Order Price"),
                    onChange: this.handleMinBasketPriceIntakeChange,
                  }}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem sm={2} xs={12} />
              <GridItem sm={10} xs={12}>
                <div>
                  <TranslationWrapper
                    tDefault={"Voer één of meerdere postcode-gebieden in. Voorbeeld:"}
                    tKey={"vestigingen.modal.testmail.form.intake_example"}
                  />{" "}
                  1000, 1001, 1002-1008, 1009AA, 1009AB, 1009AC 2, 1009AC 4a
                </div>
                <SaveButton
                  buttonText={
                    <TranslationWrapper
                      tDefault={"Add to whitelist"}
                      tKey={"postcode_blacklists.modal.copy.form.addPostcodeToWhitelist.text"}
                    />
                  }
                  disabled={this.disableSent()}
                  onClick={() => this.sent("addPostcodeToWhitelist")}
                  saving={this.state.addToWhiteList}
                />
                <SaveButton
                  buttonText={
                    <TranslationWrapper
                      tDefault={"Add to blacklist"}
                      tKey={"postcode_blacklists.modal.copy.form.addPostcodeToBlacklist.text"}
                    />
                  }
                  disabled={this.disableSent()}
                  onClick={() => this.sent("addPostcodeToBlacklist")}
                  saving={this.state.addToBlackList}
                />
                <SaveButton
                  buttonText={
                    <TranslationWrapper
                      tDefault={"Remove from list"}
                      tKey={"postcode_blacklists.modal.copy.form.removePostcodeFromList.text"}
                    />
                  }
                  disabled={this.disableSent()}
                  onClick={() => this.sent("removePostcodeFromList")}
                  saving={this.state.removeFromList}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              {/* Custom Filter: Dropdown: Whitelist / Blacklist */}
              <GridItem sm={4} xs={12}>
                <FormControl className={classes.selectFormControl} fullWidth>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    inputProps={{
                      name: "simpleSelect",
                      id: "simple-select",
                      style: { paddingTop: "32px" },
                    }}
                    onChange={(e) => {
                      let selectedView_White_FilterValue = e.target.value;
                      switch (selectedView_White_FilterValue) {
                        case "ALL":
                          this.props.setFilter("postalcodes:white", null);
                          break;
                        case "1":
                          this.props.setFilter("postalcodes:white", {
                            field: "white",
                            operator: "=",
                            value: 1,
                            selectValue: "1",
                          });
                          break;
                        case "0":
                          this.props.setFilter("postalcodes:white", {
                            field: "white",
                            operator: "=",
                            value: 0,
                            selectValue: "0",
                          });
                          break;
                      }
                    }}
                    value={this.props.filters["postalcodes:white"]?.selectValue ?? "ALL"}
                  >
                    {showActiveOptions}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <JamezzTable
                  dataMapping={[
                    { dbfield: "id", customRender: this.customRender_id },
                    { dbfield: "postcode", editable: false },
                    { dbfield: "white", customRender: this.customRender_white },
                    {
                      dbfield: "minBasketPrice",
                      editable: true,
                      inputtype: "Valuta",
                      customData: function (responseData) {
                        return {
                          value: responseData.minBasketPrice,
                          currency: responseData.valuta ?? "EUR",
                        };
                      },
                    },
                    { dbfield: "mon", editable: true, inputtype: "Switch" },
                    { dbfield: "tue", editable: true, inputtype: "Switch" },
                    { dbfield: "wed", editable: true, inputtype: "Switch" },
                    { dbfield: "thu", editable: true, inputtype: "Switch" },
                    { dbfield: "fri", editable: true, inputtype: "Switch" },
                    { dbfield: "sat", editable: true, inputtype: "Switch" },
                    { dbfield: "sun", editable: true, inputtype: "Switch" },
                  ]}
                  dbfields={"id,postcode,minBasketPrice,white,mon,tue,wed,thu,fri,sat,sun"}
                  editLink={false}
                  fetchUrl={"core/postcode_blacklists?vestiging_id=" + this.props.vestiging_id}
                  filters={this.props.filters}
                  headerIcon={<Map />}
                  headers={[
                    {
                      label: "", // hidden for user
                      sortable: true,
                      sortKey: "id",
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.naam", "Postcode"),
                      sortable: true,
                      sortKey: "postcode",
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.white", "Type"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.minBasketPrice", "Minimum Order Price"),
                      width: "10%",
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.mon", "Mon"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.tue", "Tue"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.wed", "Wed"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.thu", "Thu"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.fri", "Fri"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.sat", "Sat"),
                    },
                    {
                      label: getTranslation("postcode_blacklists.table.sun", "Sun"),
                    },
                  ]}
                  patchUrl={"core/postcode_blacklists"}
                  reduxKey={"postcode_blacklists"}
                  ref={this.jamezzTable}
                  searchUrl={"core/postcode_blacklists/search?vestiging_id=" + this.props.vestiging_id}
                  tableTitle={
                    <TranslationWrapper tDefault={"Postcode tabel"} tKey={"postcode_blacklists.table.titel"} />
                  }
                />
              </GridItem>
            </GridContainer>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["postalcodes:white"]) {
    filters["postalcodes:white"] = state.filtersV2["postalcodes:white"];
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(PostcodesModal, tafelStyle));
